import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

export const getHistoryInstance = () => browserHistory;
export default (store) => {
  // Sync history and store using default key ("routing")
  const history = syncHistoryWithStore(browserHistory, store);
  return history;
};
